export default "__VITE_ASSET__D6Lp8IZL__"